/**
 *
 * Copyright 2017 sgmelearninng
 *
 * 页面常量包，里面存放SGM移动课堂中的常量：actiontypes，url等。
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import * as env    from './constants_env'
import * as files  from './constants_file'
import * as urls   from './constants_url'

module.exports = {
    env,
    files,
    urls
}
